let Api = {
	"FINDPAGEINDUSTRYARTICLECLASSMAGETREE": "/portal-api/n/industryArticleClassMage/findIndustryArticleClassMageTree", //分页查询文章分类树
	"INDUSTRYARTICLEMAGE_FINDPAGELIST": "/portal-api/n/industryArticleMage/findPageList", //产业文章管理分页查询列表
	"INDUSTRYARTICLEMAGE_FINDINFO": "/portal-api/n/industryArticleMage/findInfo", //产业文章管理文章详情
	"INDUSTRYMODULEMAGE_FINDPAGELIST": "/portal-api/n/IndustryModuleMage/findPageList", //内容管理和关于我们模块分页查询列表
	"INDUSTRYCOLUMNMANAGE_FINDPAGELIST": "/portal-api/n/IndustryColumnManage/findList", //内容管理和关于我们模块分页查询列表
	"INDUSTRYMODULEMAGE_FINDINFO": "/portal-api/n/IndustryModuleMage/findInfo", //内容管理和关于我们模块分页查询列表
	"INDUSTRYLMODULECONTENT_FINDLIST": "/portal-api/n/IndustrylModuleContent/findList", //内容管理和关于我们模块 内容查询列表
	"INDUSTRYMANGE_FINDDEFAULT": "/portal-api/n/IndustryMange/findDefault", //查询默认产业基本信息
	"INDUSTRYFRIENDLYLINKMANAGE_FINDLIST": "/portal-api/n/IndustryFriendlyLinkManage/findList", //友情链接查询列表
	"GET_CODEBASE64": "/portal-api/n/codecBase64", //门户二维码获取
	"PROTAL_FINDDEFAULTINFO": "/portal-api/n/finishProtal/findDefaultInfo", //B2B装修复制
	"PROTAL_N_SHPROTAL_BYID": "/portal-api/n/finishProtal/findById", //查询专题

	"PROTAL_N_INDUSTRYNAVIGATE_FINDALL": "/portal-api/n/industryNavigate/findAll", //查询所有显示的导航

	"PORTAL_W_INDUSTRYARTICLEMAGE_FINDPAGELIST": "/portal-api/n/industryArticleMage/findPageList", //分页查询列表
	"BTB_W_INDUSTRYARTICLEMAGE_FINDPAGELIST": "/b2b/n/industryArticleMage/findPageList", //分页查询列表
	"PORTAL_N_VARIETY_PAGE": "/portal-api/n/variety/page",//品种名录
	"PROTAL_N_INDUSTRYCERTIFICATION_FINDALL": "/portal-api/n/IndustryCertification/findList", //查询所有商务资质

	"PORTAL_N_ARTICLEMAGE_FINDMAP": "/portal-api/n/industryArticleMage/findMap", // 主轮播样式三-资讯
	"BTB_W_ARTICLEMAGE_FINDMAP": "/b2b/n/industryArticleMage/findMap",


	"MOBILE_MOBILELOGIN": "/system/mobile/mobileLogin?ltype=buyWeb", //手机号登录
	"MOBILE_MOBILEOREMAILLOGIN": "/system/mobileOrEmailLogin?ltype=seller", //手机号登录最新
	"SYSTEM_MOBILE_VALCODE_SEND": "/system/mobile/valCode/send", //登录获取验证码
	"SYSTEM_MEMB_REGISTER": "/system/memb/register", //注册
	"SYSTEM_MEMB_CHECKMOBILEEXIST": "/system/memb/checkMobileExist", //验证手机号是否已经存在
	"SYSTEM_MEMB_CHECKMOBOREMAILEXIST": "/system/memb/checkMobOrEmailExist", //验证邮箱和手机号是否已经存在
	"SYSTEM_MEMB_CHECKLOGINNAMEEXIST": "/system/memb/checkLoginNameExist", //验证用户名是否已经存在
	"SYSTEM_MOBILE_CHECKCODE_CREATE": "/system/mobile/checkCode/create", //获取发送短信的图形验证码
	"SYSTEM_MOBILE_VALCODE_CREATE": "/system/mobile/valCode/create", //注册获取短信验证码
	"SYSTEM_EMAIL_SENDEMAILVALCODE": "/system/email/sendEmailValCode", //注册获取邮箱验证码


	"LOGIN": "/system/login?ltype=buyWeb&utype=master",//登录
	"MASTER_LOGIN": "/system/login?ltype=buyWeb&utype=master", //主账户登录
	"SUB_LOGIN": "/system/login?ltype=buyWeb&utype=sub", //子账户登录
	"MOBILE_MOBILELOGIN": "/system/mobile/mobileLogin?ltype=buyWeb", //手机号登录
	"MOBILE_MOBILEOREMAILLOGIN": "/system/mobileOrEmailLogin?ltype=seller", //手机号登录最新
	"SYSTEM_MOBILE_VALCODE_SEND": "/system/mobile/valCode/send", //登录获取验证码
	"W_MEMB_FINDENTPMEMBINFO": "/system/w/entp/findEntpInfo", //查询会员基本信息
	"N_PROTOCOL_GETPROTOCOLINFO": "/portal-api/n/protocol/getProtocolInfo", //查询会员基本信息


	"PROTAL_N_INDUSTRYMENU_FINDTREELIST": "/portal-api/n/industryMenu/findTreeList", //查询顶部菜单

	"QPSTZX_SXYZG_SXYZGLIST": "/simple-api/n/qpstzx/xsyzg/sxyzgList", //线上云展馆

	"QPSTZX_SXYZG_ZGQYLIST": "/simple-api/n/qpstzx/xsyzg/zgqyList", //线上云展馆

	"QPSTZX_SXYZG_ZGQYSPLIST": "/simple-api/n/qpstzx/xsyzg/zgqyspList", //展馆企业详情商品
	"N_INDUSTRYARTICLEMAGE_FINDPAGELIST": "/portal-api/n/industryArticleMage/findPageList", //无权限文章分页列表
	"N_INDUSTRYARTICLECLASSMAGE_FINDINDUSTRYARTICLECLASSMAGETREE": "/portal-api/n/industryArticleClassMage/findIndustryArticleClassMageTree", //无权限文章分页列表
	"N_INDUSTRYARTICLEMAGE_FINDINFO": "/portal-api/n/industryArticleMage/findInfo", //无权限文章分页列表
	"N_QPSTZX_BANNERTGL_BANNERTGL": "/simple-api/n/qpstzx/bannertgl/bannertgl", //获取banner
	"N_INDUSTRYMENU_FINDFORSEARCH": "/portal-api/n/industryMenu/findForSearch", //门户一站式搜索-搜索栏目服务
	"N_INDUSTRYMENU_FINDTJFORSEARCH": "/portal-api/n/industryMenu/findTjForSearch", //门户一站式搜索-搜索栏目服务(推荐)
	"N_QPSTZX_RCFW_MAVIN": "/simple-api/n/qpstzx/rcfw/mavinTypeList", //专家类别管理
	"N_QPSTZX_RCFW_MAVINPERSONPAGE": "/simple-api/n/qpstzx/rcfw/mavinPersonPage", //根据类型查询专家人员信息(分页)
	"N_QPSTZX_RCFW_RCFWZXADD": "/simple-api/n/qpstzx/rcfw/rcfwzxAdd", //新增人才服务咨询


	

	"N_QPSTZX_ZCDATA_ZCINDEXTYPE": "/simple-api/n/qpstzx/zcData/zcIndexType", //卓创数据指数-数据分类(有数据)
	"N_QPSTZX_ZCDATA_NEARPRICEINDEX": "/simple-api/n/qpstzx/zcData/nearPriceIndex", //卓创数据指数-近N天价格指数
	"N_QPSTZX_ZCDATA_LINEGRAPH": "/simple-api/n/qpstzx/zcData/lineGraph", //卓创数据指数-卓创折线图

	"N_QPSTZX_ZCDATA_BGZXTYPE": "/simple-api/n/qpstzx/zcData/bgzxType", //数据报告中心-类别查询(有数据)
	"N_QPSTZX_ZCDATA_BGFINDPAGE": "/simple-api/n/qpstzx/zcData/bgFindPage", //数据报告中心-分页查询

	"N_QPSTZX_ZCDATA_SHOPFINDPAGE": "/simple-api/n/qpstzx/zcData/shopFindPage", //数据产品超市-分页查询



	

	

	

	


	






  "N_QPSTZX_BANNERTGL_BANNERTGL": "/simple-api/n/qpstzx/bannertgl/bannertgl", //获取banner
  "N_INDUSTRYMENU_FINDFORSEARCH": "/portal-api/n/industryMenu/findForSearch", //门户一站式搜索-搜索栏目服务
  "N_INDUSTRYMENU_FINDTJFORSEARCH": "/portal-api/n/industryMenu/findTjForSearch", //门户一站式搜索-搜索栏目服务(推荐)
  "N_QPSTZX_RCFW_MAVIN": "/simple-api/n/qpstzx/rcfw/mavinTypeList", //专家类别管理有专家数据的
  "N_QPSTZX_RCFW_MAVINTYPEALLLIST": "/simple-api/n/qpstzx/rcfw/mavinTypeAllList", //专家类别管理所有的
  "N_QPSTZX_RCFW_MAVINPERSONPAGE": "/simple-api/n/qpstzx/rcfw/mavinPersonPage", //根据类型查询专家人员信息(分页)
  "N_QPSTZX_RCFW_RCFWZXADD": "/simple-api/n/qpstzx/rcfw/rcfwzxAdd", //新增人才服务咨询
  
	"W_PERSON_GET": "/b2b/w/person/get", //获取个人信息
  
}
module.exports = Api